import { createApp } from 'vue'
import App from './App'
import router from './router'
import api from './provider'
import store from './store'

// permission control
import './permission'

/* css */
import animated from 'animate.css' // 引入 animate.css
import '@/styles/universal.scss' // global css

// Internationalization
import i18n from './lang'

// svg icon
import { registerSvgIcon } from './icons';

import moment from "moment"
import Message from '@/components/message/message'
import utility from "@/utils/utility"

const app = createApp(App)

app.config.globalProperties.$moment = moment
app.config.globalProperties.$message = Message.install
app.config.globalProperties.$utility = utility

// 注册 SvgIcon 组件和加载 SVG 文件
registerSvgIcon(app);

app.use(api)
app.use(router)
app.use(store)
app.use(i18n)

app.mount("#app")
